import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { FormsModule } from "@angular/forms";
import { DataTableModule } from "angular2-datatable";
import { Ng2Bs3ModalModule } from "ng2-bs3-modal/ng2-bs3-modal";
import { Ng2Webstorage } from "ngx-webstorage/dist/app";
import { FileUploadModule } from "ng2-file-upload/ng2-file-upload";
import { Ng2CompleterModule } from "ng2-completer";
import { CitasAsesorVirtualComponent } from "./citas-asesor-virtual.component";
import { CitasAsesorVirtualService } from "./citas-asesor-virtual.service";
import { ApplicationPipesModule } from "../../components/pipes/safe.module";



@NgModule({
    declarations: [CitasAsesorVirtualComponent],
    imports: [
        BrowserModule,
        Ng2CompleterModule,
        HttpModule,
        FormsModule,
        DataTableModule,
        Ng2Bs3ModalModule,
        FileUploadModule,
        Ng2Webstorage,
        ApplicationPipesModule],
    providers: [CitasAsesorVirtualService]
})

export class CitasAsesorVirtualModule { }



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/citas/citas-asesor-virtual.module.ts